import { NgModule, ViewChild, ElementRef } from '@angular/core';
import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import {MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {AlertaConfirmDialog} from '../alerta-confirm';
import {AlertaSimplesDialog} from '../alerta-simples';
import { Observable, timer, Subscription, interval  } from 'rxjs';
import { take, map, finalize, catchError, subscribeOn, tap  } from 'rxjs/operators';
import { TamasAlunoService } from '../tamas-aluno.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-me-treino',
  templateUrl: './me-treino.component.html',
  styleUrls: ['./me-treino.component.css']
})
export class MeTreinoComponent implements OnInit {
  existeTreino: boolean = false;
  hideCL: boolean = false;
  counter$: Observable<number>;
  hideDescanso: boolean = true;
  tempoDescansoFake: any = 0;
  tempoDescansoPerc: any = 0;
  percentualEvol: Observable<number>;
  fatorDec: any = 0;
  fullPerc: any = 100;
  mBottomS: any;
  arrExerciciosDia: any[] = [];
  nomeTreino: any = '';
  idFicha: any = '';
  idTreino: any = '';
  constructor(private bottomSheet: MatBottomSheet,private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService,  public dialog: MatDialog) { }

  ngOnInit() {
    this.existeTreino = true;
    this.idTreino = this.route.snapshot.paramMap.get('idtreino');
    this.idFicha = this.route.snapshot.paramMap.get('idficha');
    this.montarTreino();
    this.tmaService.tempoDescansoChange.subscribe(acao =>{
      console.log("alteração no serviço");
      this.mContadorDescanso(this.tmaService.glTempoDescanso);
    });
  }

  voltar() :any{
    this.router.navigate(['me/fichatreino/' +  this.route.snapshot.paramMap.get('idficha')]);
  
  }

  montarTreino() : void{
    //aqui ter que trabalhar com algo pre salvo - fake;
    this.hideCL = false;
    this.arrExerciciosDia = [];

    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idficha=' + this.idFicha + '&idFichaTreino=' + this.idTreino;
    this.tmaService.listarTreino(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        this.nomeTreino = qRes['dadosFicha'].NomeTreino;
        this.arrExerciciosDia = qRes['arrExercicios'];
        if(this.arrExerciciosDia.length > 0){
          this.arrExerciciosDia.forEach((qItem, index) => {
            if(this.tmaService.arrExerciciosDone.find(x => x.idExercicio == qItem.Id && x.idTreino == qItem.IdTreino)){
              //var qIndexRef = this.arrRefeicoesDia.findIndex(x => x.idRefeicao == qItem.idRefeicao)
              console.log("found");
              this.arrExerciciosDia[index].done = true;
            }
            else{
              this.arrExerciciosDia[index].done = false;
            }
          });
        }
        else{
          this.voltar();
        }
      }
    })

    // this.arrExerciciosDia.push({ idTreino: 1, idExercicio: 1, numSeries:3, numRepeticoes: 10, numIntervalo: 50, qExercicio: 'Supino Inclinado', done: false });
    // this.arrExerciciosDia.push({ idTreino: 1, idExercicio: 2, numSeries:4, numRepeticoes: 8, numIntervalo: 30, qExercicio: 'Supino Declinado com halteres', done: false });
    // this.arrExerciciosDia.push({ idTreino: 1, idExercicio: 3, numSeries:4, numRepeticoes: 6, numIntervalo: 45, qExercicio: 'Crucifixo com Halteres', done: false });
    //terá que retornar do servidor, se a refeicao foi feita, com base na data
    console.log("será");
    console.log(this.tmaService.arrExerciciosDone);
    // this.arrExerciciosDia.forEach(qItem => {
    //   if(this.tmaService.arrExerciciosDone.find(x => x.idExercicio == qItem.Id && x.idTreino == qItem.IdTreino)){
    //     //var qIndexRef = this.arrRefeicoesDia.findIndex(x => x.idRefeicao == qItem.idRefeicao)
    //     console.log("found");
    //     this.arrExerciciosDia.find(x => x.idExercicio == qItem.Id && x.idTreino == qItem.IdTreino).done = true;
    //   }
    // });
    
  }

  cancelarDescanso() :void{
    this.percentualEvol = new Observable<number>();
    this.counter$ = new Observable<number>();
    this.hideDescanso = true;
    if(this.tmaService.glSerieAtual == this.tmaService.glTotalSeries){
      console.log("close bottom");
      this.mBottomS.dismiss();
    }
  }
  mContadorDescanso(qTempo : any) : void{
    console.log("start contador " + this.tmaService.glSerieAtual + " / " + this.tmaService.glTotalSeries);
    this.percentualEvol = new Observable<number>();
    this.counter$ = new Observable<number>();
    this.hideDescanso = false;
    this.tempoDescansoFake = qTempo;
    this.tempoDescansoPerc = qTempo;
    this.fatorDec =  100 / qTempo;
    this.fullPerc = 100;
    
    this.counter$ = timer(0,1000).pipe(
      take(this.tempoDescansoFake),
      map(() => --this.tempoDescansoFake),
      catchError(error => {
        console.log('error occured:', error);
        throw error;
      }),
//      tap(() => this.percentualEvol.map() ),
      finalize(() => {
        console.log('finalize');
        this.hideDescanso = true;
        if(this.tmaService.glSerieAtual == this.tmaService.glTotalSeries){
          console.log("close bottom");
          //localstorage 
          this.concluirExercicio();
          this.mBottomS.dismiss();
         
        }
      })
    )

    this.percentualEvol = timer(qTempo,1000).pipe(
      take(this.fullPerc),
      map(() => this.fullPerc = this.fullPerc - this.fatorDec),
      catchError(error => {
        console.log('error occured:', error);
        throw error;
      }),
//      tap(() => this.percentualEvol.map() ),
      finalize(() => {
        console.log('finalize');

        //this.hideDescanso = true;
      })
    )

    // this.percentualEvol = interval(1000).pipe(
    //   map((x) => {
        
    //      return x;
    //  }));
  
    console.log(this.tempoDescansoFake);
  }

  concluirExercicio() :void{
    this.tmaService.arrExerciciosDone.push({ idExercicio:  this.tmaService.glIdExercicioAtual, idTreino: this.route.snapshot.paramMap.get('idtreino') });
    this.riscarExercicio();
    //this.montarTreino();
    //verifica se já existe a storage
    if (localStorage.getItem("turboDadosCliente") !== null){

    }
  }
  riscarExercicio() :void{
    this.arrExerciciosDia.forEach((qItem, index) => {
      if(this.tmaService.arrExerciciosDone.find(x => x.idExercicio == qItem.Id && x.idTreino == qItem.IdTreino)){
        //var qIndexRef = this.arrRefeicoesDia.findIndex(x => x.idRefeicao == qItem.idRefeicao)
        console.log("found");
        this.arrExerciciosDia[index].done = true;
      }
      else{
        this.arrExerciciosDia[index].done = false;
      }
    });
  }
  detalhesExercicio(idExercicio : any, qNseries: any, qNRepete: any, qTempoDescanso, qNomeExerc: any, qLink:any): void {
    //this.bottomSheet.open(BottomSheetOverviewExampleSheet);
        //info sobre o treino, pegar o número de repetições e criar uma lista
//const bottomSheetRef
        this.mBottomS = this.bottomSheet.open(BottomSheetOverviewExampleSheet, {
            data: { status: "Teste", qtdRepeticoes: qNRepete, qtdSeries: qNseries, nomeExercicio: qNomeExerc, tempoDescanso: qTempoDescanso, idExercicio: idExercicio, youtube: qLink},
          });
          this.mBottomS.afterDismissed().subscribe((res) =>{
            console.log("bottom dismiss");
            console.log(res);
            if(res != null){
                //this.mTrocarStatus(res);
            }

          })
  }

  finalizarTreino() :void{
    
    const avisoFT = this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      //data: {iconAlerta: "check_circle_outline", tituloAlerta: "Aviso", textoAlerta: "Confirma a conclusão do treino?", textoCancel: "Não", textoConfirm: "SIM"}
      data: {iconAlerta: "", tituloAlerta: "Intensidade", textoAlerta: "Selecione o grau de intensidade deste treino", textoCancel: "Cancelar", textoConfirm: "Concluir", intensidade: true}
    });
    avisoFT.afterClosed().subscribe((result) =>{
        console.log(result);
        if(result !== false && result !== ''){
            //server side
            console.log("intensidade: " + result);
            this.hideCL = false;
            console.log("novo tempo");
            var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idficha=' + this.idFicha +  "&idfichatreino=" + this.idTreino + "&escalaborg=" + result;
            this.tmaService.salvarTreino(gDados)
            .subscribe((qRes) =>{
              console.log(qRes);
              this.hideCL = true;
              if(qRes['res'] == 'done'){
                this.voltar();
              }
              else{

              }
            })
        }
        else{
          
        }
    })

  }
  

  
}
@Component({
  selector: 'bottom-sheet-status',
  templateUrl: 'bottom-sheet-status.html',
  styleUrls: ['./bottom-sheet-status.css']
})
export class BottomSheetOverviewExampleSheet {
  statusAtual: any;
  qtdRepeticoes: any = 0;
  qtdSeries: any = 0;
  nomeExercicio: any = '';
  tempoDescanso: any = 0;
  //aqui vai ser o fator do array e o localstorage
  qIdExercicio: any = 0;
  arrHistExercicio: any[] = [];
  nSerieAtual: any = 0;
  urlYT: any = '';
  showVideo: boolean = false;
  constructor(private _sanitizer: DomSanitizer, private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewExampleSheet>, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, public dialog: MatDialog, public tmaService: TamasAlunoService) {
      
  }
  ngOnInit(){
      console.log(this.data);
      this.showVideo = false;
      if(this.data.youtube != ''){
        //https://www.youtube.com/embed/

        //check if video has watch?v=
        if(this.data.youtube.toString().indexOf('watch?v=') != -1){
          //watch
          var codVideo = this.data.youtube.substring(this.data.youtube.toString().lastIndexOf('v=') + 2, this.data.youtube.length);
          console.log(codVideo);
          this.urlYT = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + codVideo);
        }
        else{
          //encurtado
          var codVideo = this.data.youtube.substring(this.data.youtube.toString().lastIndexOf('/') +1, this.data.youtube.length);
          console.log(codVideo);
          this.urlYT = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + codVideo);
        }
        
      }
      //this.urlYT = this.data.youtube;
      this.statusAtual = this.data.status;
      this.qtdSeries = this.data.qtdSeries;
      this.tmaService.glTotalSeries = this.qtdSeries;
      this.tmaService.glSerieAtual = 0;
      this.nomeExercicio = this.data.nomeExercicio;
      this.qtdRepeticoes = this.data.qtdRepeticoes;
      this.tempoDescanso = this.data.tempoDescanso;
      this.qIdExercicio = this.data.idExercicio;

     for(var i = 1; i <= this.qtdSeries ; i++){
       if(this.tmaService.arrSeriesRlz.find( s => s.mtIdExercicio == this.qIdExercicio && s.mtNumSerie == i)){
        this.arrHistExercicio.push({ qNumSerie: i, qNumrepet: this.qtdRepeticoes,  qPeso: 0, checked: true, qIdExercicio: this.qIdExercicio });
       }
       else{
        this.arrHistExercicio.push({ qNumSerie: i, qNumrepet: this.qtdRepeticoes,  qPeso: 0, checked: false, qIdExercicio: this.qIdExercicio });
       }
        

     }

  }
  checkExDone(qPosicao : any, statusAtual: any) :void{

    //sem alerta
    console.log("novo tempo");
    console.log(statusAtual);
    //this.arrHistExercicio[qPosicao].checked = !statusAtual;
    
    if(statusAtual !== true){
      //this.nSerieAtual++;
      this.tmaService.glSerieAtual++;
      var infoTreinoEx = this.arrHistExercicio.find(c => c.qNumSerie == qPosicao);
      this.tmaService.arrSeriesRlz.push({ 'mtIdExercicio' : infoTreinoEx.qIdExercicio, 'mtNumSerie': infoTreinoEx.qNumSerie  });
      this.tmaService.glIdExercicioAtual = infoTreinoEx.qIdExercicio;
      console.log(this.tmaService.arrSeriesRlz);
      this.arrHistExercicio.find(c => c.qNumSerie == qPosicao).checked =  !statusAtual;
      this.tmaService.eventoNovoTempo(this.tempoDescanso);  
    }
    else{
      //this.nSerieAtual --;
      this.tmaService.glSerieAtual--;
      var infoTreinoEx2 = this.arrHistExercicio.find(c => c.qNumSerie == qPosicao);
      var posicaoMT = this.tmaService.arrSeriesRlz.findIndex( t => t.mtIdExercicio == infoTreinoEx2.qIdExercicio && t.mtNumSerie == qPosicao);
      console.log("posicao mt " + posicaoMT);
      this.tmaService.arrSeriesRlz.splice(posicaoMT, 1);
      console.log(this.tmaService.arrSeriesRlz);
      this.arrHistExercicio.find(c => c.qNumSerie == qPosicao).checked =  !statusAtual;
      //this.tmaService.eventoNovoTempo(this.tempoDescanso);
    }
    
    //com alerta
    //this.mAlertaConfirmacao("Série " + qPosicao + " realizada!" );
  }

  mAlertaConfirmacao(txtAlerta : any){
    const avisoData = this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: {iconAlerta: "check_circle_outline", tituloAlerta: "Exercício Realizado", textoAlerta: txtAlerta, textoConfirm: "OK"}
    });
    avisoData.afterClosed().subscribe((result) =>{
        console.log(result);
        if(result == true){
            //iniciar contador
            //this.mContadorDescanso();
            console.log("novo tempo");
            this.tmaService.eventoNovoTempo(this.tempoDescanso);
        }
        else{
          
        }
    })
  }

  

  mAlertaSimples(txtAlerta : any){
    const qqAlerta = this.dialog.open(AlertaSimplesDialog, {
        data: {textoAlerta: txtAlerta}
    });
}
  qStatus(novoStatus: any): void {

      if(novoStatus != undefined){
          const avisoData = this.dialog.open(AlertaConfirmDialog, {
              // width: '250px',
              disableClose: true,
              data: {iconAlerta: "warning", tituloAlerta: "Alterar Status", textoAlerta: "Confirma a alteração do status para <b>"+ novoStatus + "</b>?", textoCancel: "Não", textoConfirm: "SIM"}
          });
          avisoData.afterClosed().subscribe((result) =>{
              console.log(result);
              if(result == true){
                  this.bottomSheetRef.dismiss(novoStatus);
                  
              }
              else{
                 
              }
          })
      }
      
      event.preventDefault();
  }

  verVideo() :void{
    this.showVideo = true;
  }
}
